import { useEffect } from "react";

const SITE_ORIGIN = "https://jigyasaonline.com";

// Points <link rel="canonical"> and <meta property="og:url"> at this route's
// own URL. index.html ships a single static pair (pointing at "/") shared by
// every route, which made Google treat /about, /user-guide, etc. as
// duplicates of the homepage instead of indexing them separately.
export default function useCanonicalUrl(path) {
  useEffect(() => {
    const url = `${SITE_ORIGIN}${path}`;

    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) canonicalLink.href = url;

    const ogUrlMeta = document.querySelector('meta[property="og:url"]');
    if (ogUrlMeta) ogUrlMeta.content = url;
  }, [path]);
}
